<!-- <div class="fe-capacities-container"> -->
  <div class="spinner-container" *ngIf="spinnerBoolean">
    <div class="spinner"></div>
    <div class="spinner-text">Loading Water Admin data...</div>
  </div>

  <div class="table-actions-bar">
    <div class="table-title">WATER ADMIN VIEW</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">
      Clear All
    </button>
    <button *ngIf="selectedRows.length > 0" (click)="clearSelection()">
      Clear Select
    </button>
    <button *ngIf="showCancel" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <div *ngIf="dropdownLoading" class="dropdown-loading">
    Loading dropdown options...
  </div>

  <div class="table-container" [ngClass]="{ hidden: spinnerBoolean }">
    <div class="table-header-container">
      <div class="table-header-row">
        <!-- <div class="table-header-cell fixed-width-cell-1"></div> -->
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div class="text-wrap">
              {{ col.header }}
              <span *ngIf="col.required" class="required-asterisk" title="Required">*</span>
            </div>
            <div class="filter-icon-container" *ngIf="col.filterable">
              <img
                class="filter-icon"
                [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16"
                height="16"
                alt="Filter"
                [title]="isFilterActive(col.field) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                (click)="openFloatingFilter($event, col.field)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
      >
        <div
          class="table-body-row"
          [ngClass]="{ 'new-row': row.isNew }"
          *cdkVirtualFor="let row of data; let i = index"
          (mouseenter)="hoveredRowIndex = i"
          (mouseleave)="hoveredRowIndex = null"
        >
          <!-- <div class="table-header-cell fixed-width-cell-1">
            <span
              *ngIf="hoveredRowIndex === i"
              style="cursor: pointer; font-size: 16px"
              (click)="copyRow(i)"
              title="Copy this row"
            >
              📋
            </span>
          </div> -->

          <div class="table-header-cell fixed-width-cell-2">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(row)"
              (change)="toggleRowSelection(row, $event)"
            />
          </div>

          <!-- Region -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.region)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'region'); else readOnlyRegion">
                <select
                  [(ngModel)]="row.region"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'region')"
                  (ngModelChange)="onDropdownFieldChange(row, 'region', $event)"
                >
                  <option value="">-- Select Region --</option>
                  <option *ngIf="canAddNewDropdownValue(row, 'region')" value="__ADD_NEW__" class="add-new-option">
                    + Add New
                  </option>
                  <option *ngFor="let region of getRegionOptions(row)" [value]="region">
                    {{ region }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyRegion>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.region || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Dev Area -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.feDevArea)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'feDevArea'); else readOnlyFeDevArea">
                <select
                  [(ngModel)]="row.feDevArea"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'feDevArea')"
                  (ngModelChange)="onDropdownSelectionChange(row)"
                >
                  <option value="">-- Select Dev Area --</option>
                  <optgroup label="Development Areas" *ngIf="getDevelopmentAreaOptions(row).length > 0">
                    <option *ngFor="let area of getDevelopmentAreaOptions(row)" [value]="area">
                      {{ area }}
                    </option>
                  </optgroup>
                  <optgroup label="Sub Development Areas" *ngIf="getSubDevelopmentAreaOptions(row).length > 0">
                    <option *ngFor="let area of getSubDevelopmentAreaOptions(row)" [value]="area">
                      {{ area }}
                    </option>
                  </optgroup>
                  <ng-container *ngIf="getDevelopmentAreaOptions(row).length === 0 && getSubDevelopmentAreaOptions(row).length === 0">
                    <option *ngFor="let area of getFeDevAreaOptions(row)" [value]="area">
                      {{ area }}
                    </option>
                  </ng-container>
                </select>
              </ng-container>
              <ng-template #readOnlyFeDevArea>
                <div class="readonly-cell-value readonly-cell-value--wrap">
                  <span class="readonly-cell-text readonly-cell-text--wrap">{{ row.feDevArea || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- INT / Outlet / Pipeline Name -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.intOutletPipelineName)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'intOutletPipelineName'); else readOnlyFacilityName">
                <select
                  [(ngModel)]="row.intOutletPipelineName"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'intOutletPipelineName')"
                  (ngModelChange)="onDropdownFieldChange(row, 'intOutletPipelineName', $event)"
                >
                  <option value="">-- Select Facility Name --</option>
                  <option *ngIf="canAddNewDropdownValue(row, 'intOutletPipelineName')" value="__ADD_NEW__" class="add-new-option">
                    + Add New
                  </option>
                  <option *ngFor="let name of getFacilityNameOptions(row)" [value]="name">
                    {{ name }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyFacilityName>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.intOutletPipelineName || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Element Type -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.elementType)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'elementType'); else readOnlyElementType">
                <select
                  [(ngModel)]="row.elementType"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'elementType')"
                  (ngModelChange)="onDropdownSelectionChange(row)"
                >
                  <option value="">-- Select Element Type --</option>
                  <option *ngFor="let type of getElementTypeOptions(row)" [value]="type">
                    {{ type }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyElementType>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.elementType || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Pipeline Outlet Dev Area -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.pipelineOutletDevArea)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'pipelineOutletDevArea'); else readOnlyPipelineOutletDevArea">
                <select
                  [(ngModel)]="row.pipelineOutletDevArea"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'pipelineOutletDevArea') || isPipelineOutletDevAreaDisabled(row)"
                  (ngModelChange)="onDropdownSelectionChange(row)"
                >
                  <option value="">-- Select Pipeline Outlet Dev Area --</option>
                  <option *ngFor="let area of getPipelineOutletDevAreaOptions(row)" [value]="area">
                    {{ area }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyPipelineOutletDevArea>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.pipelineOutletDevArea || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Enersight Asset -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.enersightAsset)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'enersightAsset'); else readOnlyEnersightAsset">
                <select
                  [(ngModel)]="row.enersightAsset"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'enersightAsset')"
                  (ngModelChange)="onDropdownFieldChange(row, 'enersightAsset', $event)"
                >
                  <option value="">-- Select Enersight Asset --</option>
                  <option *ngIf="canAddNewDropdownValue(row, 'enersightAsset')" value="__ADD_NEW__" class="add-new-option">
                    + Add New
                  </option>
                  <option *ngFor="let asset of getEnersightAssetOptions(row)" [value]="asset">
                    {{ asset }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyEnersightAsset>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.enersightAsset || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Disposal Outlet Type -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.disposalOutletType)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'disposalOutletType'); else readOnlyDisposalOutletType">
                <select
                  [(ngModel)]="row.disposalOutletType"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'disposalOutletType')"
                  (ngModelChange)="onDropdownSelectionChange(row)"
                >
                  <option value="">-- Select Disposal Outlet Type --</option>
                  <option *ngFor="let type of getDisposalOutletTypeOptions(row)" [value]="type">
                    {{ type }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyDisposalOutletType>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.disposalOutletType || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Company -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.company)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'company'); else readOnlyCompany">
                <select
                  [(ngModel)]="row.company"
                  [disabled]="dropdownLoading || !isFieldEditable(row, 'company')"
                  (ngModelChange)="onDropdownFieldChange(row, 'company', $event)"
                >
                  <option value="">-- Select Company --</option>
                  <option *ngIf="canAddNewDropdownValue(row, 'company')" value="__ADD_NEW__" class="add-new-option">
                    + Add New
                  </option>
                  <option *ngFor="let comp of getCompanyOptions(row)" [value]="comp">
                    {{ comp }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyCompany>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.company || '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Effective Date -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'effectiveDate'); else readOnlyEffectiveDate">
                <input
                  type="date"
                  [(ngModel)]="row.effectiveDate"
                  [disabled]="!isFieldEditable(row, 'effectiveDate')"
                  (change)="handleEdit(row)"
                />
              </ng-container>
              <ng-template #readOnlyEffectiveDate>
                <div class="readonly-cell-value">{{ formatEffectiveDate(row.effectiveDate) }}</div>
              </ng-template>
            </div>
          </div>

          <!-- Priority -->
          <div class="table-header-cell">
            <div
              class="cell-wrapper value-hover-card"
              (mouseenter)="showHoverTooltip($event, row.priority)"
              (mousemove)="moveHoverTooltip($event)"
              (mouseleave)="hideHoverTooltip()"
            >
              <ng-container *ngIf="row.isNew || isFieldEditable(row, 'priority'); else readOnlyPriority">
                <select
                [(ngModel)]="row.priority"
                [disabled]="!isFieldEditable(row, 'priority')"
                (ngModelChange)="onDropdownSelectionChange(row)"
              >
                <option [ngValue]="null">-- Select Priority --</option>
                <option *ngFor="let priority of getPriorityOptions(row)" [ngValue]="priority">
                  {{ priority }}
                </option>
              </select>
              </ng-container>
              <ng-template #readOnlyPriority>
                <div class="readonly-cell-value">
                  <span class="readonly-cell-text">{{ row.priority ?? '-' }}</span>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div
      *ngIf="hoverTooltip"
      class="hover-value-tooltip"
      [ngStyle]="{ top: hoverTooltip.top + 'px', left: hoverTooltip.left + 'px' }"
    >
      {{ hoverTooltip.value }}
    </div>

    <div class="table-modal-overlay" *ngIf="showAddNewModal" (click)="closeAddNewModal()">
      <div class="table-modal-box" (click)="$event.stopPropagation()">
        <div class="table-modal-title">Add New {{ addNewModalFieldLabel }}</div>
        <div class="table-modal-content">
          <ng-container *ngIf="addNewModalField === 'region'; else singleAddNewField">
            <label class="table-modal-label" for="regionNameInput">Region Name</label>
            <input
              id="regionNameInput"
              type="text"
              [(ngModel)]="addNewRegionName"
              placeholder="Enter region name"
            />

            <label class="table-modal-label" for="developmentAreaInput">Development Area</label>
            <select
              id="developmentAreaInput"
              [(ngModel)]="addNewDevelopmentArea"
            >
              <option value="">-- Select Development Area --</option>
              <optgroup label="Development Areas" *ngIf="getAddNewPopupDevelopmentAreaOptions().length > 0">
                <option *ngFor="let area of getAddNewPopupDevelopmentAreaOptions()" [value]="area">
                  {{ area }}
                </option>
              </optgroup>
              <optgroup label="Sub Development Areas" *ngIf="getAddNewPopupSubDevelopmentAreaOptions().length > 0">
                <option *ngFor="let area of getAddNewPopupSubDevelopmentAreaOptions()" [value]="area">
                  {{ area }}
                </option>
              </optgroup>
              <ng-container *ngIf="getAddNewPopupDevelopmentAreaOptions().length === 0 && getAddNewPopupSubDevelopmentAreaOptions().length === 0">
                <option *ngFor="let area of getAddNewDevelopmentAreaOptions()" [value]="area">
                  {{ area }}
                </option>
              </ng-container>
            </select>
          </ng-container>

          <ng-template #singleAddNewField>
            <input
              type="text"
              [(ngModel)]="addNewModalValue"
              [placeholder]="'Enter ' + addNewModalFieldLabel"
              (keyup.enter)="confirmAddNewModal()"
            />
          </ng-template>
        </div>
        <div class="table-modal-actions">
          <button class="cancel-button" type="button" (click)="closeAddNewModal()">Cancel</button>
          <button class="save-button" type="button" (click)="confirmAddNewModal()">Save</button>
        </div>
      </div>
    </div>
  </div>

  <div class="loading-more" *ngIf="loading">
    <div class="loading-spinner"></div>
    <span>Loading more data...</span>
  </div>

  <div
    class="floating-filter-dropdown"
    #floatingFilterPanel
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <!-- Multi-select filter -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'multi-select'">
      <input
        type="text"
        [(ngModel)]="filterSearch[activeFilter]"
        placeholder="Search..."
      />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input
            type="checkbox"
            [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)"
          />
          <span>{{ option }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>

    <!-- Date range filter -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'date-range'">
      <div class="date-range-filter">
        <label>Start Date:</label>
        <input
          type="date"
          [(ngModel)]="dateRangeFilters.startDate"
          placeholder="Start Date"
        />
        
        <label>End Date:</label>
        <input
          type="date"
          [(ngModel)]="dateRangeFilters.endDate"
          placeholder="End Date"
        />
      </div>

      <div class="filter-buttons">
        <button (click)="applyDateRangeFilter()">Apply</button>
        <button (click)="clearDateRangeFilter()">Clear</button>
      </div>
    </ng-container>
  </div>
<!-- </div> -->

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export Water Admin View</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>
